import { render, staticRenderFns } from "./CompanySelection.vue?vue&type=template&id=7870beae&scoped=true&"
import script from "./CompanySelection.vue?vue&type=script&lang=ts&"
export * from "./CompanySelection.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySelection.vue?vue&type=style&index=0&id=7870beae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870beae",
  null
  
)

export default component.exports